export const disclaimerContent = {
  sections: [
    {
      content: "By visiting our website, downloading the Jacks app, or signing up as a user, you acknowledge and agree to the following:"
    },
    {
      title: "1. Licensing and Ownership",
      content: "The Jacks platform is operated by Jacks App Inc., which is licensed to use the intellectual property, proprietary technology, and trademarks of Jacks Holding LLC. All platform rights are reserved by Jacks Holding LLC."
    },
    {
      title: "2. No Guarantees",
      content: "Neither Jacks App Inc., Jacks Drivers Management LLC, nor their affiliates guarantee the availability, reliability, or outcomes of services accessed through the platform. Service availability is subject to demand, user-provided information, and external conditions."
    },
    {
      title: "3. Third-Party Providers",
      content: "The platform connects clients with independent contractors. Jacks App Inc. and its affiliates are not liable for the actions, performance, or conduct of these providers. All services are rendered at the user's risk."
    },
    {
      title: "4. Limitation of Liability",
      content: "Jacks App Inc., Jacks Drivers Management LLC, and their affiliates are not responsible for any direct, indirect, incidental, consequential, or punitive damages arising from the use of the platform, including service delays, interruptions, or user disputes."
    },
    {
      title: "5. User Responsibility",
      content: "Users are responsible for providing accurate information during sign-up and use of the platform. Jacks App Inc. is not liable for issues resulting from incomplete or incorrect information."
    },
    {
      title: "6. Compliance with Terms and Policies",
      content: "By using the platform, you agree to comply with the Terms of Use, Privacy Policy, and other governing agreements, which may be updated from time to time. Continued use of the platform constitutes acceptance of these terms."
    },
    {
      title: "7. Legal Compliance",
      content: "Jacks App Inc. operates in compliance with federal, state, and local laws. Users are required to comply with applicable laws when using the platform."
    },
    {
      content: "By accessing our website, downloading the Jacks app, or using our platform, you acknowledge that you have read, understood, and agreed to this disclaimer.\n\nFor further inquiries, please contact support@jacks.com.co."
    }
  ]
}; 